import { render, staticRenderFns } from "./CoozzyContent.vue?vue&type=template&id=0f37144f&scoped=true"
import script from "./CoozzyContent.vue?vue&type=script&lang=js"
export * from "./CoozzyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37144f",
  null
  
)

export default component.exports